export default __webpack_public_path__ + "static/media/china.4c3d9bc1.svg";